import type { SensorMaintenanceLensService } from '../types/sensorMaintenanceLens.types';
import { httpSensorMaintenanceLensService } from './sensorMaintenanceLensApi';

export const sensorMaintenanceLensService: SensorMaintenanceLensService =
	httpSensorMaintenanceLensService;
